import { initializeTelemetry } from "@nerdswhofish/browser-telemetry";

window.appTelemetry = initializeTelemetry({
  url: "https://faro-collector-prod-us-east-3.grafana.net/collect/7e77f465e3e2e0cb4a13c1800e31d6af",
  app: {
    name: "The Outdoor Programmer Shop",
    version: __APP_VERSION__,
    environment: "production",
  },
  routes: [
    "/",
    "/api/checkout",
    "/api/checkout/status",
    "/checkout/cancel",
    "/checkout/success",
  ],
  assets: ["/telemetry.js"],
  operations: ["checkout", "checkout-status"],
});
